// When PAYROLL_PHONE_HELP_EXPERIMENT_ENABLED is false,
// the entire payroll phone hel experiment is bypassed, and
// no users see the phone help link
export const PAYROLL_PHONE_HELP_EXPERIMENT_ENABLED = false;

export const METAL_CARD_IS_LAUNCHED = true;

// New increased direct deposit screen for RTB users
export const NUDGES_DIRECT_DEPOSIT_SCREEN_IS_LAUNCHED = true;

export const REACT_NATIVE_PINWHEEL_SDK_IS_LAUNCHED = true;

export const IS_SELF_SERVICE_EDIT_CONTACT_LAUNCHED = true;

export const IS_SELF_SERVICE_EDIT_EMAIL_LAUNCHED = true;

export const IS_SELF_SERVICE_EDIT_ADDRESS_LAUNCHED = true;

export const IS_SELF_SERVICE_EDIT_PHONE_LAUNCHED = true;

export const IS_PAYCHEX_LAUNCHED = true;

export const IS_SOLO_IN_CHECKOUT_LAUNCHED = true;
